/* -------------------------------------------------------------------------
 * Sayuri signature · heat-shimmer  (Miyagi Heat)
 * -------------------------------------------------------------------------
 * Port of `HeatShimmer` in the design file (line ~1268). No particles at
 * all — an SVG filter (fractal-noise turbulence + displacement map) warps
 * three thin horizontal accent-colored bars, plus a warm gradient glow
 * pulsing at the bottom.
 *
 * Scent character: "Charred mochi, paper lanterns, the heat that won't
 * leave the air." Summer + sticky + hypnotic.
 * ----------------------------------------------------------------------- */
(function () {
  'use strict';
  var SA = window.SayuriAnimations;
  if (!SA) { return; }

  SA.register('heat-shimmer', {
    mount: function (el, ctx) {
      var accent = ctx.accent;

      // SVG wrapper spanning the full layer, with turbulence filter.
      var svgNS = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(svgNS, 'svg');
      svg.setAttribute('width', '100%');
      svg.setAttribute('height', '100%');
      svg.style.position = 'absolute';
      svg.style.inset = '0';

      // Defs + animated turbulence filter (design file lines 1273–1279).
      svg.innerHTML =
        '<defs>' +
          '<filter id="heat-warp">' +
            '<feTurbulence type="fractalNoise" baseFrequency="0.008 0.04" numOctaves="2" seed="2">' +
              '<animate attributeName="baseFrequency" ' +
                'values="0.008 0.04;0.012 0.05;0.008 0.04" ' +
                'dur="22s" repeatCount="indefinite"/>' +    // was 8s; slow heat
            '</feTurbulence>' +
            '<feDisplacementMap in="SourceGraphic" scale="6"/>' +
          '</filter>' +
        '</defs>' +
        '<g filter="url(#heat-warp)" opacity="0.6">' +
          '<rect x="0" y="40%" width="100%" height="2" fill="' + accent + '" opacity="0.3"/>' +
          '<rect x="0" y="55%" width="100%" height="2" fill="' + accent + '" opacity="0.25"/>' +
          '<rect x="0" y="70%" width="100%" height="2" fill="' + accent + '" opacity="0.2"/>' +
        '</g>';
      el.appendChild(svg);

      // Warm gradient glow pulsing at the bottom 40vh.
      var glow = document.createElement('div');
      glow.className = 'sayuri-heat-glow';
      glow.style.position = 'absolute';
      glow.style.left = '0';
      glow.style.right = '0';
      glow.style.bottom = '0';
      glow.style.height = '40vh';
      glow.style.background =
        'linear-gradient(0deg, ' + accent + '22 0%, transparent 100%)';
      glow.style.animation = 'heat-pulse 14s ease-in-out infinite';  // was 5s; slow breath
      el.appendChild(glow);
    },
    css: '@keyframes heat-pulse { 0%,100%{opacity:0.6;} 50%{opacity:1;} }'
  });
})();
